import React from 'react';
import {
	ExperienceStart,
	ExperienceSuccess,
	useExperienceFail,
} from '@atlassian/jira-experience-tracker';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller';

export const EXPERIENCE_NAME = 'launchCard';
const ANALYTICS_SOURCE = 'versionDetails';

export const LaunchCardExperienceStart = () => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={`${Date.now()}`}
			experience={EXPERIENCE_NAME}
			analyticsSource={ANALYTICS_SOURCE}
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};

export const LaunchCardExperienceSuccess = () => <ExperienceSuccess experience={EXPERIENCE_NAME} />;

export const useLaunchCardExperienceFail = () =>
	useExperienceFail({
		experience: EXPERIENCE_NAME,
	});
